import { render } from "./ViewContainer.vue?vue&type=template&id=739a412e"
import script from "./ViewContainer.vue?vue&type=script&lang=ts"
export * from "./ViewContainer.vue?vue&type=script&lang=ts"
script.render = render

export default script